import { CacheHit } from './cache/cache-hit';
import { CacheMiss } from './cache/cache-miss';
import { CacheCleared } from './cache/cache-cleared';
import { CacheDeleted } from './cache/cache-deleted';
import { CacheWritten } from './cache/cache-written';
import { BusMessageReceived } from './bus/bus-message-received';
import { BusMessagePublished } from './bus/bus-message-published';

export const events = {
  BusMessagePublished,
  BusMessageReceived,
  CacheHit,
  CacheMiss,
  CacheCleared,
  CacheDeleted,
  CacheWritten,
};
